const layoutConfig = {
  'two-item': {
    label: 'Two Items Per Row',
    columnCount: 2,
    compactRating: false
  },
  'three-item': {
    label: 'Three Items Per Row',
    columnCount: 3,
    compactRating: true
  },
  'four-item': {
    label: 'Four Items Per Row',
    columnCount: 4,
    compactRating: true
  }
};
export default layoutConfig;
